import axios from 'axios'

export default {
  namespaced: true,
  state: {
    states: [],
    countries: []
  },
  mutations: {
    SET_STATES (state, states) {
      state.states = states
    },
    SET_COUNTRIES (state, countries) {
      state.countries = countries
    }
  },
  getters: {
  },
  actions: {
    getLookupStates ({ commit, state, rootState }, forceRefresh = false) {
      if (!forceRefresh && state.states.length > 0) {
        return Promise.resolve({ data: { states: state.states } })
      }
      return axios.get(
        `/api/company/${rootState.userCurrentCompany.companyId}/lookup/states`
      ).then(r => {
        commit('SET_STATES', r.data.states || [])
        return r
      }).catch(e => {
        console.log(`Error loading states: ${e.response && e.response.status}`)
      })
    },
    getLookupCountries ({ commit, state, rootState }, forceRefresh = false) {
      if (!forceRefresh && state.countries.length > 0) {
        return Promise.resolve({ data: { countries: state.countries } })
      }
      return axios.get(
        `/api/company/${rootState.userCurrentCompany.companyId}/lookup/countries`
      ).then(r => {
        commit('SET_COUNTRIES', r.data.countries || [])
        return r
      }).catch(e => {
        console.log(`Error loading countries: ${e.response && e.response.status}`)
      })
    }
  }
}
